export const DATA_ITEM_TYPE_PREFIX = 'dnditemtype/'

export const getTime =
  window.performance && window.performance.now
    ? window.performance.now.bind(window.performance)
    : 'function' == typeof Date.now
    ? Date.now
    : function () {
        return Date.now()
      }

export const requestAnimationFrame =
  null != window.requestAnimationFrame
    ? window.requestAnimationFrame
    : (function () {
        let lastCallTime = null
        return function requestAnimationFrame(callback) {
          const currentTime = getTime()
          const nextFrameAfter = null == lastCallTime ? 16 : Math.max(0, 16 - Math.floor(currentTime - lastCallTime))
          const nextCallTime = currentTime + nextFrameAfter
          lastCallTime = nextCallTime
          return setTimeout(function () {
            callback(nextCallTime)
          }, nextFrameAfter)
        }
      })()

export const cancelAnimationFrame =
  null != window.cancelAnimationFrame
    ? window.cancelAnimationFrame
    : function (requestID) {
        clearTimeout(requestID)
      }

export function getScrollX() {
  return null != window.scrollX
    ? window.scrollX
    : null != window.pageXOffset
    ? window.pageXOffset
    : (document.documentElement || document.body.parentNode || document.body).scrollLeft
}

export function getScrollY() {
  return null != window.scrollY
    ? window.scrollY
    : null != window.pageYOffset
    ? window.pageYOffset
    : (document.documentElement || document.body.parentNode || document.body).scrollTop
}

const fileTypeRegExp = /file/i
const filePromiseTypeRegExp = /file-promise/i
export function dragContainsFiles(event) {
  if (event && event.dataTransfer && event.dataTransfer.types) {
    for (let i = 0; i < event.dataTransfer.types.length; i++) {
      const type = event.dataTransfer.types[i]
      if (type && fileTypeRegExp.test(type) && !filePromiseTypeRegExp.test(type)) {
        return true
      }
    }
  }
  return false
}

export function itemTypeFromEvent(event) {
  if (event && event.dataTransfer && event.dataTransfer.types) {
    for (let i = 0; i < event.dataTransfer.types.length; i++) {
      const dataTransferType = event.dataTransfer.types[i]
      if (dataTransferType.slice(0, DATA_ITEM_TYPE_PREFIX.length) == DATA_ITEM_TYPE_PREFIX) {
        return dataTransferType.slice(DATA_ITEM_TYPE_PREFIX.length)
      }
    }
  }
  return null
}

export function getItemType(state, event) {
  if (null != state.source) {
    return state.source.PUBLIC.getType()
  } else if (dragContainsFiles(event)) {
    return 'files'
  } else {
    return itemTypeFromEvent(event)
  }
}

export const isMac = 0 <= navigator.platform.search(/mac/i) ? () => true : () => false
// Option is the Mac clone modifier: WebKit treats Shift+drag as a selection gesture and never
// fires dragstart, so Shift can't reach us there. Shift stays accepted for Blink on Mac.
export function isCloningEvent(event) {
  return isMac() ? event.shiftKey || event.altKey : event.shiftKey || event.ctrlKey
}
